module.exports = __webpack_public_path__ + "img/capibara.7efb3f97.png";